<!-- <p-panel header="{{ 'WEEKLY_SCHEDULE'  | translate }}" styleClass="p-panel-whitebg mb-3">-->
<p-accordionTab (selectedChange)="togglePanel($event)">
	<ng-template pTemplate="header">
		<div class="flex align-items-center justify-content-between w-full -my-3">
			<div class="font-semibold">{{ 'WEEKLY_SCHEDULE' | translate }}</div>
			<!--<p-button *ngIf="online" pTooltip="{{ 'RELOAD' | translate }}" tooltipPosition="bottom" icon="pi cm-reload"
					size="large" (click)="$event.stopPropagation(); loadTimers()" [rounded]="false" [text]="true"
					severity="primary">
				</p-button>-->
		</div>
	</ng-template>
	<div class="grid">
		<div class="col-12">
			<p-table #tableWeeklySchedule dataKey="ObjId" [value]="weeklySchedules" [lazy]="true"
				(onLazyLoad)="loadWeeklySchedules($event)" [paginator]="true" [totalRecords]="totalRecords"
				[loading]="weeklySchedulesLoading" [rows]="weeklySchedulesPageSize" [showCurrentPageReport]="true"
				currentPageReportTemplate="{{ 'TABLE_REPORT' | translate }}" [autoLayout]="true" responsiveLayout="stack">
				<ng-template pTemplate="caption">
					<div class="grid">
						<div [class]="actionLayout('left')">
							<p-button id="addWeeklySchedule" label="{{ 'ADD_WEEKLY_SCHEDULE' | translate }}"
								(click)="addWeeklySchedule()"
								[disabled]="weeklySchedulesMemorySize>=weeklySchedulesMaxMemorySize || !online|| taskRunning"
								icon="pi cm-plus" [rounded]="false" [text]="true" severity="primary"
								styleClass="font-bold border-primary">
							</p-button>
						</div>
						<div [class]="actionLayout('center')">
							<div class="flex flex-column justify-content-center gap-2">
								<span class="flex align-items-center justify-content-center">
									<i class="pi cm-memory-storage mr-1"></i>
									{{'MEMORY_USAGE' | translate }}: {{weeklySchedulesMemorySize}} /
									{{weeklySchedulesMaxMemorySize}}
								</span>
								<p-progressBar [value]="getValueMemory()">
									<ng-template pTemplate="content" let-value>
										<span *ngIf="getValueMemory() > 4">{{ getValueMemory() }} %</span>
									</ng-template>
								</p-progressBar>
							</div>
						</div>
						<div [class]="actionLayout('right')">
							<span class="p-input-icon-left" [class]="dynamicInputSearchWidth()">
								<i class="pi cm-search"></i>
								<input [formControl]="searchFilter" pInputText type="text" id="control-access-weekly-schedule-input-search"
									placeholder="{{ 'SEARCH' | translate }}" [ngClass]="dynamicInputSearchWidth()"
									maxlength="60" />
							</span>
						</div>
					</div>
				</ng-template>
				<ng-template pTemplate="header" class="flex align-items-center justify-content-center">
					<tr>
						<th>
							<div class="flex align-items-center justify-content-center">{{ 'NAME' | translate }}</div>
						</th>
						<th>
							<div class="flex align-items-center justify-content-center">{{ 'PROGRAMMING' | translate }}</div>
						</th>
						<th>
							<div class="flex align-items-center justify-content-center"></div>
						</th>
					</tr>
				</ng-template>
				<ng-template pTemplate="body" let-weeklySchedule>
					<tr>
						<td>
							<span class="p-column-title font-semibold">{{ 'NAME' | translate }}</span>
							<div class="flex align-items-center justify-content-center">{{ weeklySchedule.Name }}</div>
						</td>
						<td>
							<span class="p-column-title font-semibold">{{ 'PROGRAMMING' | translate }}</span>
							<div class="flex flex-row align-items-center justify-content-center"
								[class]="underTablet() ? 'grid' : ''">
								<div
									[class]="underTablet() ? 'col-12 flex flex-row align-items-center justify-content-end pb-0' : 'flex flex-row'">
									<!--  DATE  -->
									<div class="flex flex-row align-items-center justify-content-center w-15_5rem">
										<p-button *ngFor="let day of weeklySchedule.WeekdaysList;"
											styleClass="p-button-weeklyschedulebgwhite w-2rem h-2rem flex justify-content-center hover:bg-primary cursor-auto"
											[text]="!day.Enable" [disabled]="!day.Enable"
											[severity]="day.Enable === true ? 'primary' : 'primary'"
											label="{{ day.Name | translate | firstLetter }}">
										</p-button>
									</div>
								</div>
								<div
									[class]="underTablet() ? 'col-12 flex flex-row align-items-center justify-content-end gap-2 pb-0' : 'flex flex-row gap-2'">
									<!--  TIME  -->
									<div class="flex flex-row align-items-center justify-content-center text-center gap-2">
										{{ "DATE_FROM" | translate }}:
										<p class="font-bold">{{ weeklySchedule.TimeFrom+':00' }}</p>
									</div>
									<div class="flex flex-row align-items-center justify-content-center text-center gap-2">
										{{ "DATE_TO" | translate }}:
										<p class="font-bold">{{ weeklySchedule.TimeTo+':59' }}</p>
									</div>
								</div>
							</div>
						</td>
						<td>
							<span class="p-column-title"></span>
							<div class="flex flex-row justify-content-center align-items-center gap-1">
								<p-button pTooltip="{{ 'EDIT' | translate}}" [disabled]="!online|| taskRunning"
									id="buttonWeeklyScheduleEdit-{{weeklySchedule.Name}}" tooltipPosition="bottom"
									icon="pi cm-pencil" size="large" (click)="editWeeklySchedule(weeklySchedule)"
									[rounded]="false" [text]="true" severity="secondary">
								</p-button>
								<p-button pTooltip="{{ 'DELETE' | translate}}" [disabled]="!online|| taskRunning"
									id="buttonWeeklyScheduleDelete-{{weeklySchedule.Name}}" tooltipPosition="bottom"
									icon="pi cm-trash" size="large" (click)="deleteWeeklySchedule(weeklySchedule)"
									[rounded]="false" [text]="true" severity="danger">
								</p-button>
							</div>
						</td>
					</tr>
				</ng-template>
				<ng-template pTemplate="emptymessage">
					<tr>
						<td colspan="7">{{ 'TABLE_NO_ELEMENT' | translate }}</td>
					</tr>
				</ng-template>
			</p-table>
		</div>
	</div>
</p-accordionTab>
<p-confirmDialog #confDialog>
	<ng-template pTemplate="footer">
		<div class="col-12 flex justify-content-center">
			<button type="button" pButton [label]="confDialog.acceptButtonLabel" [ngClass]="acceptButtonStyle"
				(click)="confDialog.accept()">
			</button>
			<button type="button" pButton [label]="confDialog.rejectButtonLabel" [ngClass]="rejectButtonStyle"
				(click)="confDialog.reject()">
			</button>
		</div>
	</ng-template>
</p-confirmDialog>